import {enumItems} from './enumItems';
import {SchemaWithClient} from '../types/SchemaWithClient';
import {Client} from '../services/Client';
import {NumberField} from '../components/Table/fields/NumberField';
import {TextField} from '../components/Table/fields/TextField';
import {SelectField} from '../components/Table/fields/SelectField';
import {activity} from './activity';
import {address} from './address';
import {DateField} from '../components/Table/fields/DateField';
import {TimeField} from '../components/Table/fields/TimeField';
import {statuses} from './statuses';
import {SelectFieldWithoutAutocomplete} from '../components/Table/fields/SelectFieldWithoutAutocomplete';
import {SPTextField} from '../components/Table/fields/SPTextField';
import {SPDateField} from '../components/Table/fields/SPDateField';
import {SPTimeField} from '../components/Table/fields/SPTimeField';
import {SPSelectField} from '../components/Table/fields/SPSelectField';
import {SPNumberField} from '../components/Table/fields/SPNumberField';
import {SPSelectWithOutAutocomplete} from '../components/Table/fields/SPSelectWithOutAutocompleteField';
import {ServiceReservationFinance} from '../components/LegalAndFinance/ServiceReservationFinance';
import {ServiceReservationLog} from '../components/Log/ServiceReservationLog';
import {RichTextField} from '../components/Table/fields/RichTextField';
import {SPRichTextField} from '../components/Table/fields/SPRichTextField';
import {SPDateTimeField} from '../components/Table/fields/SPDateTimeField';
import {FileField} from '../components/Table/fields/FileField';
import {DateTimeField} from '../components/Table/fields/DateTimeField';
import {userByRole} from './userByRole';
import {ServiceReservationComment} from "../components/Comment/ServiceReservationComment";
import {CustomFields} from "../components/Custom/ServiceReservation/CustomFields";
import {Finance} from "../components/ServiceReservation/Finance";
import {FullWidthCustomFields} from "../components/ServiceReservation/FullWidthCustomFields";
import {SPSelectVenueAddressField} from "../components/Table/fields/SPSelectVenueAddressField";
import {servicePackage} from "./servicePackage";
import {service} from "./service";
import {serviceProvider} from "./serviceProvider";
import {CustomFieldForServiceReservationStaff} from "../components/Table/fields/CustomFieldForServiceReservationStaff";
import {
  CustomFieldForServiceReservationDriver
} from "../components/Table/fields/CustomFieldForServiceReservationDriver";
import {serviceProviderDriver} from "./serviceProviderDriver";
import {serviceProviderEventStaff} from "./serviceProviderEventStaff";
import {
  CustomFieldForServiceReservationVehicle
} from "../components/Table/fields/CustomFieldForServiceReservationVehicle";
import {serviceProviderVehicle} from "./serviceProviderVehicle";

export const serviceReservationViewTable: SchemaWithClient<any> = {
  name: 'Service Reservations View',
  pluralName: 'Service Reservations',
  hasCheckField: true,
  showDeleted: true,
  breadcrumb: ['Group', 'Activity Reservation', 'Service Reservation'],
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
    {
      id: 2,
      label: 'Finances',
      name: 'finances',
      type: 'custom',
      renderer: ServiceReservationFinance,
    },
    {
      id: 3,
      label: 'Comments',
      name: 'comments',
      type: 'custom',
      renderer: ServiceReservationComment,
      rendererType: 'service_reservations',
    },
    {
      id: 4,
      label: 'History',
      name: 'logs',
      type: 'custom',
      renderer: ServiceReservationLog,
    },
  ],
  sections: [
    {
      id: 1,
      width: 6,
      label: 'General Data',
      name: 'general',
      grids: [
        {
          width: 6,
          columns: [
            {
              columnName: 'group',
              name: 'Group',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.group),
              readOnly: true,
            },
            {
              columnName: 'activity',
              name: 'Activity',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.activity),
              readOnly: true,
            },
            {
              columnName: 'service_reservation_type',
              name: 'Type',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.serviceReservationType),
              readonly: true,
            },
            {
              columnName: 'option_expiry',
              name: 'Option Expiry',
              fieldRenderer: SPDateTimeField,
            },
            {
              columnName: 'service_package',
              name: 'Service Group',
              fieldRenderer: SPSelectField.tableAdapter(servicePackage()),
              readOnly: true,
              accordingTo: 'activity_reservation',
            },
            {
              columnName: 'service_provider',
              name: 'Service Provider',
              fieldRenderer: SPSelectField.tableAdapter(serviceProvider),
              readOnly: true,
              accordingTo: 'activity',

            },
            {
              columnName: 'service',
              name: 'Service',
              fieldRenderer: SPSelectField.tableAdapter(service),
              readOnly: true,
              accordingTo: 'service_provider',
            },
          ],
        },
        {
          width: 6,
          columns: [
            {
              columnName: 'service_reservation_status',
              name: 'Status',
              fieldRenderer: SPSelectWithOutAutocomplete.tableAdapter(
                statuses.serviceReservationStatus
              ),
            },
            {
              grid: true,
              columns: [
                {
                  columnName: 'date',
                  name: 'Date',
                  fieldRenderer: SPDateField,
                },
                {
                  columnName: 'start_time',
                  name: 'Start Time',
                  fieldRenderer: SPTimeField,
                },
              ],
            },
            {
              grid: true,
              columns: [
                {
                  columnName: 'group_size',
                  name: 'Group Size',
                  fieldRenderer: SPNumberField,
                },
                {
                  columnName: 'pickup_time',
                  name: 'Pickup Time',
                  fieldRenderer: SPTimeField,
                },
              ],
            },
            {
              columnName: 'staff',
              name: 'Staff',
              fieldRenderer: CustomFieldForServiceReservationStaff,
            },
            {
              columnName: 'driver',
              name: 'Driver',
              fieldRenderer: CustomFieldForServiceReservationDriver,
            },
            {
              columnName: 'meeting_place',
              name: 'Meeting Place',
              fieldRenderer: SPSelectVenueAddressField.tableAdapter(address),
            },
            {
              columnName: 'venue',
              name: 'Venue',
              fieldRenderer: SPSelectVenueAddressField.tableAdapter(address),
            },

          ],
        },

        {
          width: 8,
          columns: [
            {
              columnName: 'notes',
              name: 'Notes',
              fieldRenderer: SPRichTextField,
            },
          ],
        },
      ]
    },
    {
      id: 2,
      width: 6,
      label: 'Chat',
      name: 'chat',
      hasDefaultButtons: true,
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'chat',
              fieldRenderer: ServiceReservationComment,
            },
          ],
        },
        {
          width: 12,
          columns: [
            {
              grid: true,
              columns: [
                {
                  columnName: 'custom_fields',
                  name: 'Custom Fields',
                  fieldRenderer: FullWidthCustomFields,
                },
                {
                  columnName: 'files',
                  name: 'Manual Confirmation',
                  fieldRenderer: FileField,
                },
              ],
            },
          ],
        },

      ],
    },
    {
      id: 3,
      width: 8,
      label: 'Finance',
      name: 'finance',
      grids: [
        {
          width: 12,
          columns: [
            {
              columnName: 'finance',
              fieldRenderer: Finance,
            },
          ],
        },
      ],
    },
  ],
  columns: {
    group: {
      name: 'Group',
      fieldRenderer: SelectField.tableAdapter(enumItems.group),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.group),
      url: enumItems.group.client.getAllPath,
      tempSchema: enumItems.group,
      switchboard: true,
      accordingTo: 'date',
      readOnly: true,
       fieldType: 'one-link',
      linkUrl: 'groups',
    },
    activity: {
      name: 'Activity',
      fieldRenderer: SelectField.tableAdapter(activity),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(activity),
      url: activity.client.getAllPath,
      tempSchema: activity,
      switchboard: true,
      readOnly: true,
       fieldType: 'one-link',
      linkUrl: 'activity-reservations',
    },
    service_reservation_type: {
      name: 'Type',
      fieldRenderer: SelectField.tableAdapter(enumItems.serviceReservationType),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.serviceReservationType
      ),
      url: enumItems.serviceReservationType.client.getAllPath,
      tempSchema: enumItems.serviceReservationType,
      switchboard: true,
    },
    option_expiry: {
      name: 'Option Expiry',
      fieldRenderer: DateTimeField,
      slidePaneFieldRenderer: SPDateTimeField,
      fieldType: 'dateTime',
    },
    service_reservation_status: {
      name: 'Status',
      fieldRenderer: SelectFieldWithoutAutocomplete.tableAdapter(
        statuses.serviceReservationStatus
      ),
      slidePaneFieldRenderer: SPSelectWithOutAutocomplete.tableAdapter(
        statuses.serviceReservationStatus
      ),
      url: statuses.serviceReservationStatus.client.getAllPath,
      tempSchema: statuses.serviceReservationStatus,
      switchboard: true,
      fieldType: 'status',
    },
    service_package: {
      name: 'Service Group',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPSelectField.tableAdapter(servicePackage()),
      url: servicePackage().client.getAllPath,
      tempSchema: servicePackage(),
      switchboard: true,
      accordingTo: 'activity_reservation',
    },
    service_provider: {
      name: 'Service Provider',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPSelectField.tableAdapter(serviceProvider),
      url: serviceProvider.client.getAllPath,
      tempSchema: serviceProvider,
      switchboard: true,
      fieldType: 'one-link',
      accordingTo: 'activity',
      linkUrl: 'service-providers',
      readOnly: true,
    },
    service: {
      name: 'Service',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPSelectField.tableAdapter(service),
      url: service.client.getAllPath,
      tempSchema: service,
      switchboard: true,
      editOnlyByAdmin: true,
      accordingTo: 'service_provider',
      readOnly: true,
    },
    selected_staff: {
      name: 'Staff',
      fieldRenderer: SelectField.tableAdapter(userByRole('9')),
      slidePaneFieldRenderer: CustomFieldForServiceReservationStaff,
      url: userByRole('9').client.getAllPath,
      tempSchema: serviceProviderEventStaff,
      switchboard: true,
      accordingTo: 'activity_reservation',
      fieldType: 'custom_field_for_service_reservation_staff',
    },
    driver: {
      name: 'Driver',
      fieldRenderer: SelectField.tableAdapter(userByRole('7')),
      slidePaneFieldRenderer: CustomFieldForServiceReservationDriver,
      url: userByRole('7').client.getAllPath,
      tempSchema: serviceProviderDriver,
      switchboard: true,
      accordingTo: 'activity_reservation',
      fieldType: 'custom_field_for_service_reservation_driver',
    },
    vehicle: {
      name: 'Vehicle',
      fieldRenderer: SelectField.tableAdapter(enumItems.vehicle),
      slidePaneFieldRenderer: CustomFieldForServiceReservationVehicle,
      url: enumItems.vehicle.client.getAllPath,
      tempSchema: serviceProviderVehicle,
      switchboard: true,
      accordingTo: 'activity_reservation',
      fieldType: 'custom_field_for_service_reservation_vehicle',
    },
    group_size: {
      name: 'Size',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    date: {
      name: 'Date',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    pickup_time: {
      name: 'Pickup Time',
      fieldRenderer: TimeField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
    },
    start_time: {
      name: 'Start Time',
      fieldRenderer: TimeField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
    },

    address_from: {
      name: 'Meeting Place',
      fieldRenderer: SelectField.tableAdapter(address),
      slidePaneFieldRenderer: SPSelectVenueAddressField.tableAdapter(address),
      switchboard: true,
      url: address.client.getAllPath,
      tempSchema: address,
       fieldType: 'address',
    },
    address_to: {
      name: 'Venue',
      fieldRenderer: SelectField.tableAdapter(address),
      slidePaneFieldRenderer: SPSelectVenueAddressField.tableAdapter(address),
      switchboard: true,
      url: address.client.getAllPath,
      tempSchema: address,
       fieldType: 'address',
    },
    original_cost: {
      name: 'Original Cost',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      readOnly: true,
      notSortable: true,
      fieldType: 'priceWithCurrency',
    },
    final_cost: {
      name: 'Final Cost',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      notSortable: true,
      fieldType: 'priceWithCurrency',
    },
    files: {
      name: 'Manual Confirmation',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: FileField,
      fieldType: 'file',
      style: {
        marginBottom: '30px',
      },
    },
    notes: {
      name: 'Notes',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'editable-textarea',
    },
    name: {
      name: 'Name',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      readOnly: true,
      hide: true,
      hideInTableView: true,
    },
    custom_fields: {
      name: 'Custom Fields',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: CustomFields,
      fieldType: 'custom',
      hideInTableView: true,
      withoutNameColumn: true,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  viewTable: 'service_reservations',
  client: new Client(`/service-reservations-view`),
};
